import React, { Component } from "react";
import { Typography } from "@material-ui/core";

class InstructionText extends Component {
  state = {};
  render() {
    return (
      <React.Fragment>
        <Typography variant="h5">Instructions:</Typography>
        <Typography variant="button">
          - By submitting, you will completely replace current database with the
          loaded file
        </Typography>
        <br />
        <Typography variant="button">
          - Be careful, with each submittion, database contents will be forever
          lost (it is recommended to download current database contents before
          submitting)
        </Typography>
        <br />
        <Typography variant="button">
          - To append data to current database, you will need to download it
          first and then add rows you would like to be appended
        </Typography>
        <br />
        <Typography variant="button"></Typography>
      </React.Fragment>
    );
  }
}

export default InstructionText;
